import Image from 'next/image';

import styles from './logo.module.css';
import { useBottomNavigation } from '../../bottom-navigation.context';

export type LogoProps = {
  logo: {
    src: string;
    width: number;
    height: number;
    href?: string | undefined;
  };
};

export const Logo = ({ logo: { src, width, height, href } }: LogoProps) => {
  const { linkFactory } = useBottomNavigation();
  const children = <Image src={src} width={width} height={height} alt="" />;

  return (
    <div className={styles.logoWrapper}>
      {href
        ? linkFactory({
            href,
            children,
          })
        : children}
    </div>
  );
};
